import { render } from "./statement-of-account.vue?vue&type=template&id=8ae98a52"
import script from "./statement-of-account.vue?vue&type=script&lang=js"
export * from "./statement-of-account.vue?vue&type=script&lang=js"

import "./statement-of-account.vue?vue&type=style&index=0&id=8ae98a52&lang=css"

import exportComponent from "/Users/newuser/Herd/spider-project-frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__